'use client'

import { createMobileRecharge } from '@/lib/api/financial/digital-account-api'
import { useState } from 'react'
import { MdPhoneAndroid } from 'react-icons/md'
import { toast } from 'react-toastify'
import PasswordField from './password-field'

const OPERATORS = ['VIVO', 'CLARO', 'TIM', 'OI', 'NEXTEL', 'CORREIOS']
const PRESET_VALUES = [10, 15, 20, 25, 30, 50, 100]

export default function RechargeModal({ onClose, onSuccess }: { onClose: () => void; onSuccess: () => void }) {
    const [phone, setPhone] = useState('')
    const [value, setValue] = useState<number | null>(null)
    const [operator, setOperator] = useState('VIVO')
    const [password, setPassword] = useState('')
    const [sending, setSending] = useState(false)

    const handleSend = async () => {
        if (!phone.replace(/\D/g, '') || !value || !operator) {
            return toast.warning('Preencha todos os campos')
        }
        if (!password) return toast.warning('Confirme sua senha')
        setSending(true)
        try {
            const res = await createMobileRecharge({
                phoneNumber: phone.replace(/\D/g, ''),
                value,
                operator,
                password,
            })
            if (res.success) {
                toast.success('Recarga enviada')
                onSuccess()
            } else {
                toast.error(res.error || 'Erro ao recarregar')
            }
        } finally {
            setSending(false)
        }
    }

    return (
        <div className="modal modal-open">
            <div className="modal-box max-w-sm">
                <h3 className="font-bold text-lg flex items-center gap-2 mb-4">
                    <MdPhoneAndroid className="text-orange-500" /> Recarga de celular
                </h3>

                <div className="space-y-3">
                    <div className="flex flex-col gap-1">
                        <span className="text-sm font-medium text-base-content/80">Telefone (com DDD)</span>
                        <input className="input input-bordered input-sm" placeholder="(11) 99999-9999" value={phone} onChange={e => setPhone(e.target.value)} />
                    </div>

                    <div className="flex flex-col gap-1">
                        <span className="text-sm font-medium text-base-content/80">Operadora</span>
                        <select className="select select-bordered select-sm" value={operator} onChange={e => setOperator(e.target.value)}>
                            {OPERATORS.map(o => <option key={o} value={o}>{o}</option>)}
                        </select>
                    </div>

                    <div>
                        <span className="text-sm font-medium text-base-content/80">Valor</span>
                        <div className="grid grid-cols-4 gap-2">
                            {PRESET_VALUES.map(v => (
                                <button
                                    key={v}
                                    type="button"
                                    onClick={() => setValue(v)}
                                    className={`btn btn-sm ${value === v ? 'btn-secondary' : 'btn-ghost'}`}
                                >
                                    {v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                </button>
                            ))}
                        </div>
                    </div>

                    <PasswordField value={password} onChange={setPassword} disabled={sending} />
                </div>

                <div className="modal-action">
                    <button className="btn btn-ghost btn-sm" onClick={onClose} disabled={sending}>Cancelar</button>
                    <button className="btn btn-secondary btn-sm" onClick={handleSend} disabled={sending}>
                        {sending ? <span className="loading loading-spinner loading-xs" /> : 'Recarregar'}
                    </button>
                </div>
            </div>
            <div className="modal-backdrop" onClick={() => !sending && onClose()} />
        </div>
    )
}
